/* eslint-disable react/no-unused-state */
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable react/destructuring-assignment */
import 'rc-notification/assets/index.css';
import React, { useRef, Component } from "react";
import { Row, Col, } from 'reactstrap';
import Notification from 'rc-notification';
import { Table, Button, Popconfirm, Upload } from "antd";
// Replace react-excel-renderer with xlsx
import * as XLSX from 'xlsx';
import SmallLoader from '../../../../shared/components/SmallLoader';
import history from '../../../App/History';
import ProductResizableTable from '../../UploadProductExcel/ProductResizableTable';
import { tableHeaderDataForUploadPOSNew as tableHeaderData } from "../../helper";

export default class POSExcelImportNew extends Component {
  constructor(props) {
    super(props);
    this.input = React.createRef();
    this.tableData = { tableHeaderData: [], tableRowsData: [] };
    this.isEmptyCell = false;
    this.isError = false;
    this.isLoading = false;
    this.errorMessage = '';
    this.cogsNumberCount = 0;
    this.emptyCellCount = 0;
    this.emptyCellErrorMessage = '';
    this.cogsErrorMessage = '';
    this.state = {
      cols: [],
      rows: [],
      regexp: /^\$?[0-9.,]+$/,
      errorMessage: null,
      columns: [
        {
          title: "Retailer",
          dataIndex: "retailer",
          editable: true,
          width: 160
        },
        {
          title: "Week Ending",
          dataIndex: "weekEnding",
          editable: true,
          width: 150
        },
        {
          title: "Product Description",
          dataIndex: "productDescription",
          editable: true,
          width: 260
        },
        {
          title: "UPC",
          dataIndex: "upc",
          editable: true,
          width: 160
        },
        {
          title: "Door Count",
          dataIndex: "doorCount",
          editable: true,
          width: 140
        },
        {
          title: "Total Sales ($)",
          dataIndex: "totalSalesAmount",
          editable: true,
          width: 160
        },
        {
          title: "Total Units",
          dataIndex: "totalUnits",
          editable: true,
          width: 140
        },
        {
          title: "Store $",
          dataIndex: "storeSalesAmount",
          editable: true,
          width: 140
        },
        {
          title: "Store Units",
          dataIndex: "storeUnits",
          editable: true,
          width: 140
        },
        {
          title: ".com $",
          dataIndex: "dotcomSalesAmount",
          editable: true,
          width: 140
        },
        {
          title: ".com Units",
          dataIndex: "dotcomUnits",
          editable: true,
          width: 140
        },
        {
          title: "UPC (New)",
          dataIndex: "upcNew",
          editable: true,
          width: 180
        },
        {
          title: "Updated Name",
          dataIndex: "updatedName",
          editable: true,
          width: 220
        },
        {
          title: "Category",
          dataIndex: "category",
          editable: true,
          width: 160
        },
        {
          title: "Grouped Name",
          dataIndex: "groupedName",
          editable: true,
          width: 200
        },
        {
          title: "Description (Trimmed)",
          dataIndex: "descriptionTrimmed",
          editable: true,
          width: 260
        },
        {
          title: "Innovation",
          dataIndex: "innovation",
          editable: true,
          width: 130
        },
        {
          title: "$PSPW",
          dataIndex: "pspwAmount",
          editable: true,
          width: 120
        },
        {
          title: "UPSPW",
          dataIndex: "upspw",
          editable: true,
          width: 120
        },
        {
          title: "Month (1~12)",
          dataIndex: "month",
          editable: true,
          width: 150
        },
        {
          title: "Year",
          dataIndex: "year",
          editable: true,
          width: 110
        },
        {
          title: "Month / Year",
          dataIndex: "monthYear",
          editable: true,
          width: 140
        },
        {
          title: "Store Count Zero",
          dataIndex: "storeCountZero",
          editable: true,
          width: 160
        },
        {
          title: "Calculated $PSPW",
          dataIndex: "calculatedPspwAmount",
          editable: true,
          width: 170
        },
        {
          title: "Calculated UPSPW",
          dataIndex: "calculatedUpspw",
          editable: true,
          width: 170
        },
        {
          title: "Week",
          dataIndex: "retailCalendarWk",
          editable: true,
          width: 100
        }
      ]
    };
  }

  handleSave = (row) => {
    const newData = [...this.state.rows];
    const index = newData.findIndex(item => row.key === item.key);
    const item = newData[index];
    newData.splice(index, 1, {
      ...item,
      ...row
    });
    this.setState({ rows: newData });
  };

  clearData = () => {
    this.setState({ rows: [] })
    this.input.current.value = ""
  }

  // Excel stores dates as serial numbers; with cellDates:true, XLSX parses
  // real date cells into JS Date objects instead (anchored to UTC midnight).
  // We read them back with UTC getters so the local browser timezone can
  // never shift the calendar date by a day. Falls back to manual serial
  // parsing (also UTC-anchored) if a raw number slips through instead.
  toJsDate = (value) => {
    console.log(`value -${value}`);
    if (value instanceof Date && !Number.isNaN(value.getTime())) return value;
    if (typeof value === 'number') {
      const parsed = XLSX.SSF.parse_date_code(value);
      console.log(`parsed -${parsed.y}-${parsed.m}-${parsed.d}`);
      if (parsed) return new Date(Date.UTC(parsed.y, parsed.m - 1, parsed.d));
    }
    return null;
  }

  // e.g. "08-01-2026"
  formatDate = (value) => {
    const date = this.toJsDate(value);
    console.log(`date -${date}`);
    if (!date) return String(value || '');
    const mm = String(date.getUTCMonth() + 1).padStart(2, '0');
    const dd = String(date.getUTCDate()).padStart(2, '0');
    console.log(`Format date ${mm}-${dd}-${date.getUTCFullYear()}`);
    return `${mm}-${dd}-${date.getUTCFullYear()}`;
  }

  // e.g. "Aug-26"
  formatMonthYear = (value) => {
    const date = this.toJsDate(value);
    if (!date) return String(value || '');
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    console.log(`monthYear ${monthNames[date.getUTCMonth() + 1]}-${String(date.getUTCFullYear()).slice(-2)}`);
    return `${monthNames[date.getUTCMonth() + 1]}-${String(date.getUTCFullYear()).slice(-2)}`;
  }

  // Strips $ signs, commas, and stray spaces from currency-like cells
  cleanCurrency = (value) => {
    if (value === undefined || value === null || value === '') return '0';
    const stringValue = String(value).replace(/\$|,/g, '').trim();
    return this.state.regexp.test(stringValue) ? stringValue : '0';
  }

  // Converts a grid row (edit-friendly field names/strings) into the
  // shape WholeSalePOSNewDTO expects on the backend, with numeric fields
  // sent as actual numbers rather than strings.
  toNumber = (value) => {
    if (value === undefined || value === null || value === '') return null;
    const parsed = Number(String(value).replace(/\$|,/g, '').trim());
    return Number.isNaN(parsed) ? null : parsed;
  }

  mapRowsToDto = (rows) => rows.map((row) => ({
    retailer: row.retailer || row.companyName,
    weekEnding: row.weekEnding,
    productDescription: row.productDescription || row.description,
    upc: row.upc,
    doorCount: this.toNumber(row.doorCount),
    totalSalesAmount: this.toNumber(row.totalSalesAmount ?? row.amount),
    totalUnits: this.toNumber(row.totalUnits ?? row.quantitySold),
    storeSalesAmount: this.toNumber(row.storeSalesAmount ?? row.storeAmount),
    storeUnits: this.toNumber(row.storeUnits),
    dotcomSalesAmount: this.toNumber(row.dotcomSalesAmount ?? row.onlineAmount),
    dotcomUnits: this.toNumber(row.dotcomUnits ?? row.onlineUnits),
    upcNew: row.upcNew || row.key,
    updatedName: row.updatedName,
    category: row.category,
    groupedName: row.groupedName,
    descriptionTrimmed: row.descriptionTrimmed,
    innovation: row.innovation,
    pspwAmount: this.toNumber(row.pspwAmount ?? row.pspw),
    upspw: this.toNumber(row.upspw),
    month: row.month,
    year: this.toNumber(row.year),
    monthYear: row.monthYear,
    storeCountZero: row.storeCountZero,
    calculatedPspwAmount: this.toNumber(row.calculatedPspwAmount ?? row.calculatedPspw),
    calculatedUpspw: this.toNumber(row.calculatedUpspw),
    retailCalendarWk: this.toNumber(row.retailCalendarWk ?? row.week),
  }));

  onImportExcel = (event) => {
    const { files } = event.target;
    console.log(files[0].type)
    if (files.length === 1) {
      if (!(files[0].type === "application/vnd.ms-excel" ||
        files[0].type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")) {
        Notification.newInstance({}, (notification) => {
          notification.notice({
            content: 'Unknown file format. Only Excel files are uploaded!',
            duration: 5,
            closable: true,
            style: { top: 120, fontWeight: "bold" },
            maxCount: 50
          });
        });
        this.setState({
          errorMessage: "Unknown file format. Only Excel files are uploaded!"
        });
      }
      else {
        // Use SheetJS to read the Excel file
        const reader = new FileReader();
        reader.onload = (e) => {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: 'array', cellDates: true });

          // Get the first worksheet
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];

          // Convert to JSON
          const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

          // Column order matches the RSS Import File layout:
          // 0 Retailer, 1 Week Ending, 2 Product Description, 3 UPC, 4 Door Count,
          // 5 Total Sales ($), 6 Total Units, 7 Store $, 8 Store Units, 9 .com $,
          // 10 .com Units, 11 UPC (New), 12 Updated Name, 13 Category, 14 Grouped name,
          // 15 Description (Trimmed), 16 Innovation, 17 $PSPW, 18 UPSPW, 19 Month,
          // 20 Year, 21 Month / Year, 22 Store Count Zero, 23 Calculated $PSPW,
          // 24 Calculated UPSPW, 25 Retail Calendar Wk
          const newRows = [];
          // Skip the header row (index 0) and process data rows
          jsonData.slice(1).forEach((row, index) => {
            if (row && row.length > 0) {
              if (row[11] !== undefined || row[2] !== undefined || row[0] !== undefined) {
                newRows.push({
                  key: String(row[11] || index),
                  retailer: String(row[0] || ''),
                  weekEnding: this.formatDate(row[1]),
                  productDescription: String(row[2] || ''),
                  upc: String(row[3] || ''),
                  doorCount: row[4] === undefined ? '0' : String(row[4]),
                  totalSalesAmount: this.cleanCurrency(row[5]),
                  totalUnits: row[6] === undefined ? '0' : String(row[6]),
                  storeSalesAmount: this.cleanCurrency(row[7]),
                  storeUnits: row[8] === undefined ? '0' : String(row[8]),
                  dotcomSalesAmount: this.cleanCurrency(row[9]),
                  dotcomUnits: row[10] === undefined ? '0' : String(row[10]),
                  upcNew: String(row[11] || ''),
                  updatedName: String(row[12] || ''),
                  category: String(row[13] || ''),
                  groupedName: String(row[14] || ''),
                  descriptionTrimmed: String(row[15] || ''),
                  innovation: String(row[16] || ''),
                  pspwAmount: this.cleanCurrency(row[17]),
                  upspw: row[18] === undefined ? '0' : String(row[18]),
                  month: String(row[19] || ''),
                  year: String(row[20] || ''),
                  monthYear: this.formatMonthYear(row[21]),
                  storeCountZero: String(row[22] || ''),
                  calculatedPspwAmount: this.cleanCurrency(row[23]),
                  calculatedUpspw: row[24] === undefined ? '0' : String(row[24]),
                  retailCalendarWk: String(row[25] || ''),
                });
              }
            }
          });

          if (this.isError === true) {
            this.errorMessage = this.cogsErrorMessage
            Notification.newInstance({}, (notification) => {
              notification.notice({
                content: <span>{this.errorMessage}</span>,
                duration: 10,
                onClose() {
                  console.log('closable close');
                },
                closable: true,
                onClick() {
                  console.log('clicked!!!');
                },
                style: { top: 120, fontWeight: "bold" },
              });
            });
          } else {
            this.isError = false;
            this.isEmptyCell = false;
          }

          console.log(newRows)
          if (newRows.length === 0) {
            Notification.newInstance({}, (notification) => {
              notification.notice({
                content: 'No data found in file!',
                duration: 10,
                style: { top: 120, fontWeight: "bold" },
                maxCount: 50
              });
            });
          } else {
            this.setState({
              cols: [], // SheetJS doesn't provide cols in the same format
              rows: newRows,
              errorMessage: null
            });
          }
        };
        reader.readAsArrayBuffer(files[0]);
      }
    }
    else {
      Notification.newInstance({}, (notification) => {
        notification.notice({
          content: 'No file uploaded!',
          duration: 10,
          closable: true,
          style: { top: 120, fontWeight: "bold" },
          maxCount: 50
        });
      });
      this.setState({
        errorMessage: "No file uploaded!"
      });
      return false;
    }
    return false;
  };

  navigateToDetails = () => {
    if (this.props && this.props.navigate) {
      this.props.navigate('/pos/details/new');
    } else {
      window.location.href = '/pos/details/new';
    }
  };

  handleSubmit = async () => {
    Notification.newInstance({}, (notification) => {
      notification.notice({
        content: 'Please wait....',
        duration: 10,
        style: { top: 200, fontWeight: "bold" },
        maxCount: 40
      });
    });
    const token = localStorage.getItem('easydev');
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token
      },
      body: JSON.stringify(this.mapRowsToDto(this.state.rows))
    };
    this.isLoading = true;
    const response = await fetch('https://rss.getrael.com/api/wholesale/pointofsalesnew/update', requestOptions);
    const data = await response.json();
    if (data.code === '200') {
      this.isLoading = false;
      this.setState({ rows: [] })
      this.input.current.value = ""
      this.navigateToDetails();
    }
    else if (data.code === '403') {
      this.isLoading = false;
      history.push('/login')
    }
    else {
      this.isLoading = false;
      Notification.newInstance({}, (notification) => {
        notification.notice({
          content: 'Point of sales not upload, Please try again!',
          duration: 10,
          closable: true,
          style: { top: 120, fontWeight: "bold" },
          maxCount: 50
        });
      });
      console.log("Point of sales not upload, Please try again!")
    }
  };

  handleDelete = (key) => {
    const rows = [...this.state.rows];
    this.setState({ rows: rows.filter(item => item.key !== key) });
  };

  handleAdd = () => {
    const { count, rows } = this.state;
    const newData = {
      key: count,
      name: "User's name",
      age: "22",
      gender: "Female"
    };
    this.setState({
      rows: [newData, ...rows],
      count: count + 1
    });
  };

  render() {
    console.log(this.isLoading)
    const components = {
      body: {
        //  row: EditableFormRow,
        //  cell: EditableCell
      }
    };
    const columns = this.state.columns.map((col) => {
      if (!col.editable) {
        return col;
      }
      return {
        ...col,
        onCell: record => ({
          record,
          editable: col.editable,
          dataIndex: col.dataIndex,
          title: col.title,
          handleSave: this.handleSave
        })
      };
    });
    return (
      <>
        <Col md={12}>
          <Row>
            <Col md="6">
              <input className="file-uploader" type="file" accept=".xlsx, .xls, .csv" onChange={this.onImportExcel}
                ref={this.input} />
              &nbsp;<Button className="btn btn-sm btn-danger"
                style={{ marginTop: 16 }}
                onClick={this.clearData}
              >
                &nbsp;Clear
              </Button>
            </Col>
            <Col md="6" align="right">
              {this.state.rows.length > 0 && (
                <>
                  <Button
                    onClick={this.handleSubmit}
                    size="large"
                    type="primary"
                    className="btn btn-primary btn-sm"
                    disabled={this.isEmptyCell}
                    style={{ marginBottom: 16, marginLeft: 10, marginTop: 16 }}
                  >
                    Submit Data
                  </Button>
                </>
              )}
              <Button
                onClick={this.navigateToDetails}
                size="large"
                type="danger"
                className="btn btn-primary btn-sm"
                style={{ marginBottom: 16, marginLeft: 10, marginTop: 16 }}
              >
                Back To Product
              </Button>
            </Col>
          </Row>
          <Row>
            <Col md={12} lg={12}>
              <div className="top-location"
                style={{ minHeight: '400' }}>
                <div >
                  {this.isLoading ? <div style={{ minHeight: '200px' }}
                    className="row align-items-center justify-content-center">
                    <SmallLoader loading={this.isLoading} />
                  </div>
                    : <ProductResizableTable customClass="pt-0" reactTableData={{ tableHeaderData }}
                      data={this.state.rows} />}
                </div>
              </div>

            </Col>
          </Row>
        </Col>
      </>
    );
  }
}